// extracted by mini-css-extract-plugin
export default {"contentWrapper":"_33cp4VXUZthVWvHLAqDlUJ"};